import { Grid } from '@material-ui/core';
import { Button, Text, View } from 'src/components/common';
import { ISchedulingDepositions } from '../type';
import React from 'react';

const Detail = ({ label, content }: { label: string; content: string | number | null }) => {
  return (
    <>
      <Text variant="title" size={14}>
        {label ? label : '--'}
      </Text>
      <Text className="mb-16" size={14}>
        {content ? content : '--'}
      </Text>
    </>
  );
};

const SubmissionDetails: React.VFC<SubmissionDetailsProps> = ({
  scheduleDepositionItem,
  onNext,
  onInitialDeposition,
}) => {
  const {
    name,
    lawFirm,
    attorneyName,
    isNeedConferenceRoom,
    deponent,
    email,
    phoneNumber,
    depositionDate,
    depositionTime,
    depositionLocation,
    city,
    caseName,
    additionalNotes,
  } = scheduleDepositionItem;
  return (
    <View className="ctn-schedule-submission">
      <Grid container spacing={1}>
        <Grid item xs={12} sm={6}>
          <Detail label="Name" content={name} />
          <Detail label="Law Firm" content={lawFirm} />
          <Detail label="Noticing Attorney Name" content={attorneyName} />
          <Detail label="Deposition Location" content={depositionLocation} />
          <Detail label="Need a Conference Room?" content={isNeedConferenceRoom ? 'Yes' : 'No'} />
          <Detail label="Deponent" content={deponent} />
        </Grid>
        <Grid item xs={12} sm={6}>
          <Detail label="Email" content={email} />
          <Detail label="Phone Number" content={phoneNumber} />
          <Detail label={`Date & Time of Deposition`} content={`${depositionDate} at ${depositionTime}`} />
          <Detail label="City" content={city} />
          <Detail label="Case Name" content={caseName} />
          <Detail label="Additional Notes" content={additionalNotes} />
        </Grid>
      </Grid>

      <View isRow justify={'space-between'} className="mt-32">
        <Button variant="primary" onClick={onInitialDeposition}>
          Initiate Deposition
        </Button>
        <Button variant="secondary" onClick={onNext}>
          EDIT
        </Button>
      </View>
    </View>
  );
};

type SubmissionDetailsProps = {
  scheduleDepositionItem: ISchedulingDepositions;
  onNext: () => void;
  onInitialDeposition: () => void;
};

export default SubmissionDetails;
